// extracted by mini-css-extract-plugin
module.exports = {"heading":"Heading__heading","subHeading":"Heading__subHeading"};